import React, { useEffect, useState } from 'react'
import apiskills from '../ApiData/SkillsTools.json'
import SkillApi from './SkillApi';
import aos from "aos";
import "aos/dist/aos.css";
const Skills = () => {
    document.title="💻 Skills | Rian Islam"

    useEffect(() => {
        aos.init({ duration: 2000 });
      }, []);

    const [skill,setSkills] = useState([]);
    useEffect(() =>{
        setSkills(apiskills.skills);
        
    },[])
    return (
        <div  className="container py-5 text-white">
        <h1 data-aos="fade-right"  className="text-center pt-5">Skills</h1>
        <p data-aos="fade-left"  className="text-center pb-5">Language and Technology that I have learned and Applied to my projects</p>

            <div data-aos="fade-up"  className="row g-4">
            
            {skill.map(sk => <SkillApi skill={sk}></SkillApi> )}

            
            </div>
        </div>
    )
}

export default Skills
